import axios from 'axios';

const api = '/api/druzstvo-anniversary-sheets';

export const generateSheets = id => {
  return axios.get(`${api}/generate/${id}?cacheBuster=${new Date().getTime()}`);
};

export const downloadSheets = id => {
  return axios.get(`${api}/download/${id}?cacheBuster=${new Date().getTime()}`);
};
